export default "__VITE_ASSET__ac2bc1a6__"